"use client";
import { atom } from "jotai";
import creatPopupAtoms, {
  ProductPopupAtom,
  ProductReviewAtomProps,
  SubmitProductReviewAtomProps,
} from "@/utils/factory/createPopupAtom";

export const filterIconAtom = atom(false);
export const progressAtom = atom(false);
export const serverLoadingAtom = atom(false);
export const productPopupAtoms = creatPopupAtoms<ProductPopupAtom>(null);
export const productPriceInfoAtoms = creatPopupAtoms<true>(null);
export const productReviewsPopupAtoms =
  creatPopupAtoms<ProductReviewAtomProps>(null);
export const submitproductReviewPopupAtoms =
  creatPopupAtoms<SubmitProductReviewAtomProps>(null);
